<template>
  <v-app id="inspire">
    <div
      v-if="
        $route.name === 'page-login' || $route.name === 'page-forgotpassword'
      "
    />
    <v-app-bar
      v-else
      app
      :src="require('../src/assets/images/header_bg.jpg')"
      color="#103A5D"
      prominent
      hide-on-scroll
      dark
      absolute
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(35,115,201,.6), rgba(29,29,29,.7)"
          @click="goto('', { isLogin: true })"
        ></v-img>
      </template>
      <v-toolbar-title>
        <div class="name-come">
          <router-link to="/"
            ><img
              width="200"
              :src="require('../src/assets/logo/gulf-logo.png')"
          /></router-link>
          <p class="subtitle-2" v-if="activeUserInfo.companyName">
            Welcome, {{ activeUserInfo.companyName }}
          </p>
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn dark text :href="adminURL" target="_blank">
        <v-icon left>mdi-account-outline</v-icon>
        Admin
      </v-btn>

      <v-btn text href="https://www.gulf.co.th" target="_blank">
        <v-icon left>mdi-home-city-outline</v-icon>
        Gulf's Website
      </v-btn>

      <v-btn text @click="logout" v-if="isLoggedIn">
        <v-icon left>mdi-logout-variant</v-icon>
        Logout
      </v-btn>
      <template v-slot:extension>
        <v-tabs centered icons-and-text v-model="tab">
          <v-tab
            v-for="(item, index) in itemsTab"
            :key="index"
            @click="goto(item.components, item)"
            >{{ item.header }}<v-icon>{{ item.icon }}</v-icon></v-tab
          >
        </v-tabs>
      </template>
    </v-app-bar>
    <v-main
      v-if="
        $route.name === 'page-login' || $route.name === 'page-forgotpassword'
      "
      ><v-parallax height="100vh" dark src="./assets/images/header_bg.jpg">
        <router-view />
      </v-parallax>
    </v-main>
    <v-main v-else>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, index) in itemsTab" :key="index">
          <div class="px-sm-2 py-sm-6 px-md-16 py-md-6">
            <router-view />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-main>
    <v-alert
      class="alert"
      :value="Boolean(noti)"
      prominent
      :type="noti.type"
      max-width="400"
      transition="slide-x-reverse-transition"
    >
      <v-row align="center">
        <v-col class="grow">
          <h3>{{ noti.title }}</h3>
          {{ noti.text }}
        </v-col>
      </v-row>
    </v-alert>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    tab: 1,
    plantTab: false,
    alert: false,
    adminURL: process.env.VUE_APP_ADMIN_URL,
    itemsTab: [
      {
        header: "Bidding Announcement",
        icon: "mdi-bullhorn-variant",
        components: "announcement",
        isLogin: false,
      },
      {
        header: "Invitation to Bid",
        icon: "mdi-gavel",
        components: "",
        isLogin: true,
      },
      {
        header: "Vendor Profile",
        icon: "mdi-account-circle",
        components: "profile",
        isLogin: true,
      },
      {
        header: "Vendor Guide",
        icon: "mdi-book-open-variant",
        components: "vendorguide",
        isLogin: false,
      },
      {
        header: "Plant Location",
        icon: "mdi-factory",
        components: "plant-address",
        isLogin: true,
      },
      {
        header: "Vendor Info",
        icon: "mdi-newspaper",
        components: "vendorinfo",
        isLogin: false,
      },
    ],
  }),
  mounted() {
    if (
      !this.isLoggedIn
      && window.location.pathname !== "/vendor/en/consentpdpa/readonly"
      && window.location.pathname !== "/vendor/th/consentpdpa/readonly"
    ) {
      this.$router.push(`/${this.$i18n.locale}/login`).catch(() => {});
    }
  },
  computed: {
    noti() {
      return this.$store.state.notify;
    },
    loading() {
      return this.$store.state.loading;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  watch: {
    $route(route) {
      switch (route.name) {
        case "page-announcement":
          this.tab = 0;
          break;
        case "home":
        case "consentpdpa":
          this.tab = 1;
          break;
        case "profile":
        case "page-register":
        case "consentpdpa-readonly":
          this.tab = 2;
          break;
        case "page-vendorguide":
          this.tab = 3;
          break;
        case "plant-address":
          this.tab = 4;
          break;
        case "page-vendorinfo":
          this.tab = 5;
          break;
        case "page-alert-login":
          this.tab = this.plantTab ? 4 : 1;
          break;
        default:
          this.tab = 0;
          break;
      }
      this.plantTab = false;
    },
  },
  methods: {
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.goto("login");
      });
    },
    setTab(route) {
      switch (route) {
        case "page-announcement":
          this.tab = 0;
          break;
        case "profile":
          this.tab = 2;
          break;
        case "page-register":
          this.tab = 2;
          break;
        case "page-vendorguide":
          this.tab = 3;
          break;
        case "page-vendorinfo":
          this.tab = 5;
          break;
        default:
          this.tab = 1;
          break;
      }
    },
    goto(path, item) {
      if (item) {
        if (item.isLogin) {
          if (this.isLoggedIn) {
            this.$router.push(`/${this.$i18n.locale}/${path}`).catch(() => {});
          } else {
            if (item.components === "profile") {
              this.$router
                .push(`/${this.$i18n.locale}/register`)
                .catch(() => {});
            } else {
              if (item.components === "plant-address") this.plantTab = true;
              this.$router
                .push(`/${this.$i18n.locale}/alert-login`)
                .catch(() => {});
            }
          }
        } else {
          this.$router.push(`/${this.$i18n.locale}/${path}`).catch(() => {});
        }
      } else {
        this.$router.push(`/${this.$i18n.locale}/${path}`).catch(() => {});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.name-come {
  width: max-content;
}
.alert {
  // position: absolute;
  bottom: 1rem;
  right: 1rem;
  z-index: 99;
  position: fixed;
  // left: 50%;
  // bottom: 50px;
  //transform: translate(-50%, -50%);
  margin: 0 auto; // Without this the box extends the width of the page
}
</style>
